'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  padding: 10px 20px;\n'], ['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  padding: 10px 20px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-', ': 10px;\n'], ['\n  margin-', ': 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var border = _ref.border;
  return border ? 'solid' : 'none';
}, _colors.grey);

var Btn = _styledComponents2.default.div(_templateObject2, function (_ref2) {
  var margin = _ref2.margin;
  return margin;
}); // Helpers


var extractAttributes = function extractAttributes(opts) {
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'red';
  var attributes = {
    size: 'small'
  };
  attributes.onClick = opts.onClick;
  attributes.theme = opts.theme || theme;
  if (opts.icon) attributes.icon = opts.icon;
  if (opts.loading) attributes.loading = opts.loading;
  if (opts.disabled) attributes.disabled = opts.disabled;
  return attributes;
};

var CardFooter = function CardFooter(_ref3) {
  var left = _ref3.left,
      right = _ref3.right,
      border = _ref3.border;
  return !left.length && !right.length ? null : _react2.default.createElement(Container, {
    border: border
  }, _react2.default.createElement('div', null, left.map(function (button, index) {
    return _react2.default.createElement(Btn, {
      key: index,
      margin: 'right'
    }, _react2.default.createElement(_Button2.default, extractAttributes(button, 'grey'), button.label || null));
  })), _react2.default.createElement('div', null, right.map(function (button, index) {
    return _react2.default.createElement(Btn, {
      key: index,
      margin: 'left'
    }, _react2.default.createElement(_Button2.default, extractAttributes(button), button.label || null));
  })));
};

CardFooter.propTypes = {
  left: _propTypes2.default.array,
  right: _propTypes2.default.array,
  border: _propTypes2.default.bool
};
exports.default = CardFooter;